export default __webpack_public_path__ + "64fd20dbae9065bb8a066380cd2bfaa9.png";